import { TypeChecker } from '@attain-apps/type-guards'

export interface Item<TValue = unknown> {
  /**
   * Representing the value for the option for selection,
   * consumer needs to make sure that this will be unique
   * for each option. If the value does not exist,
   * the label will be used for equality checking.
   * Examples:
   *
   * Use value (id) for equality checking
   * ```ts
   * {
   *  label: 'Option 1',
   *  value: 'id-option-1'
   * }
   * ```
   *
   * Use label for equality checking
   * ```ts
   * {
   *   label: 'Option 2',
   * }
   * ```
   *
   * Implement on select callback which will be called when the option is selected
   * ```ts
   * {
   *   label: 'Option 2',
   *   value: 'id-option-2'
   *   onSelect: () => {
   *     console.log('Option 2 is selected');
   *   }
   * }
   * ```
   */
  value?: TValue
  /**
   * The label to display for the select item.
   */
  label: string
  /**
   * An callback that will be called when 'this' option gets selected.
   */
  onSelect?: () => void
}
export namespace Item {
  export const isItem = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.object<Item>({
      label: TypeChecker.isString,
      onSelect: TypeChecker.Factory.optional(TypeChecker.isFunction),
      value: TypeChecker.Factory.optional(TypeChecker.isUnknown),
    }),
  )
}
